import Vue from "vue";
import VueRouter from "vue-router";

import firebase from "firebase/app";

// Tells Vuejs to use the routing plugin.
Vue.use(VueRouter);

const noteRoute = {
  path: "notes",
  name: "Notes",
  props: true,
  component: () =>
    import(/* webpackChunckName: "note" */ "../views/Notes.vue")
};

const createNoteRoute = {
  path: "notes/create",
  name: "CreateNote",
  meta: { requiresAuth: true },
  component: () =>
    import(/* webpackChunckName: "create_note" */ "../views/CreateNote.vue")
};

const itemRoute = {
  path: "category/:cat_id/item/:item_id",
  name: "SingleItem",
  meta: { requiresAuth: true },
  component: () =>
    import(/* webpackChunckName: "item" */ "../views/SingleItem.vue")
};

const categoryRoute = {
  path: "category/:cat_id",
  name: "SingleCategory",
  meta: { requiresAuth: true },
  component: () =>
    import(/* webpackChunckName: "category" */ "../views/SingleCategory.vue"),
};

const ratingRoute = {
  path: "rating/:which_rate",
  name: "RatingForm",
  props: true,
  meta: { requiresAuth: true },
  component: () =>
    import(/* webpackChunckName: "rating" */ "../views/RatingForm.vue")
};

// Defines the routes of the app.
const userRoutes = [
  {
    path: "",
    name: "Home",
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunckName: "home" */ "../views/Home.vue")
  },
  {
    path: "/help",
    name: "Help",
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunckName: "help" */ "../views/Help.vue")
  },
  {
    path: "/profile",
    name: "Profile",
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunckName: "profile" */ "../views/Profile.vue")
  },
  {
    path: "/group",
    name: "GroupSelection",
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunckName: "group_selection" */ "../views/GroupSelection.vue")
  },
  {
    path: "tasks",
    name: "Tasks",
    props: true,
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "note" */ "../views/Tasks.vue"),
  },
  {
    path: "tasks/create",
    name: "CreateTask",
    props: true,
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "create_task" */ "../views/CreateTask.vue")
  },
  {
    path: "/group/:group_id",
    name: "Group",
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunckName: "group" */ "../views/Group.vue"),
    
    children: [
      {
        path: "ContextSelection",
        redirect: "context/default",
        name: "ContextSelection",
        meta: { requiresAuth: true },
        component: () =>
          import(/* webpackChunckName: "context_selection" */ "../views/ContextSelection.vue")
      },
      {
        path: "context/:context_id/",
        meta: { requiresAuth: true },
        component: () =>
          import(/* webpackChunckName: "context_wrapper" */ "../views/ContextWrapper.vue"),
        
        children: [
          {
            path: "",
            name: "Context",
            meta: { requiresAuth: true },
            component: () =>
              import(/* webpackChunckName: "context_wrapper" */ "../views/Context.vue"),
          },
          categoryRoute,
          itemRoute,
          ratingRoute,
          noteRoute,
          createNoteRoute
        ]
      }
    ]
  }
];

const appRoutes = [
  {
    path: "/",
    component: () =>
      import(/* webpackChunckName: "user_app" */ "../views/UserApp.vue"),
    
    children: userRoutes
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunckName: "login" */ "../views/Login.vue")
  },
  {
    path: "/signup",
    name: "SignUp",
    component: () =>
      import(/* webpackChunckName: "signup" */ "../views/SignUp.vue")
  },
  {
    path: "*",
    name: "PageNotFound",
    component: () =>
      import(/* webpackChunckName: "404" */ "../views/PageNotFound.vue"),
  }
];
// Sets up the Vue Router. It is responsible for routing different urls to
// different vue components. In this setup, a component can also be a view
// (see views directory). A like a page, except it can be loaded without a
// page reload. The rendering of the current view component is handled by
// this router.
const router = new VueRouter({
  routes: appRoutes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!firebase.auth().currentUser) {
      next({
        name: "Login",
        query: { redirect: to.fullPath }
      });
    } else if (to.path === "/") {
      next({
        replace: true,
        name: "Context",
        params: {
          group_id: firebase.auth().currentUser.uid,
          context_id: "default"
        }
      });
    } else next();
  } else next();
});

export default router;
